import React from "react";
import Default from "../img/default-devolution.png";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";

interface DevolutionItemProps {
  devolucao: {
    id: string;
    imgs: { url: string }[];
    created_at: string;
    status: {
      color: string;
      status: string;
      title: string;
    };
    order_id?: string;
  };
}

const DevolutionItem: React.FC<DevolutionItemProps> = ({ devolucao }) => {
  const navigate = useNavigate();

  const formatDate = (dateTimeString: string) => {
    const options: Intl.DateTimeFormatOptions = { year: "numeric", month: "numeric", day: "numeric" };
    return new Date(dateTimeString).toLocaleDateString("pt-BR", options);
  };

  const handleFollowClick = () => {
    navigate("/follow", { state: { devolutionId: devolucao.id } });
  };

  return (
    <Box key={devolucao.id} width={{ xs: "40vw", md: 300 }}>
      <button onClick={handleFollowClick} style={{ border: "none", background: "transparent", cursor: "pointer" }}>
        {Array.isArray(devolucao.imgs) && devolucao.imgs.length > 0 ? (
          <Box width={{ xs: "40vw", md: 300 }}>
            <img src={devolucao.imgs[0].url} alt="Devolução" style={{ width: "100%", borderRadius: 10 }} />
          </Box>
        ) : (
          <Box width={{ xs: "40vw", md: 300 }}>
            <img src={Default} style={{ width: "100%" }} alt="ImgDefault" />
          </Box>
        )}
        <p style={{ textAlign: "left", fontSize: 19 }}>Solicitação #{devolucao.id}</p>
        <p style={{ textAlign: "left" }}>{formatDate(devolucao.created_at)}</p>

        <Box
          position={"relative"}
          bottom={{ xs: 110, md: 90 }}
          left={5}
          bgcolor={"#fff"}
          width={{ xs: "30vw", md: 'fit-content' }}
          p={1}
          borderRadius={10}
          display={"flex"}
          alignItems={"center"}
          gap={1}>
          <Box width={25} height={25} bgcolor={`${devolucao.status.color}`} borderRadius={100} />
          <p>{devolucao.status.title}</p>
        </Box>
      </button>
    </Box>
  );
};
export default DevolutionItem;
